"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosClient = void 0;
var ClientProvider_1 = require("./ClientProvider");
var axios_1 = require("axios");
var AxiosClient = (function (_super) {
    __extends(AxiosClient, _super);
    function AxiosClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AxiosClient.prototype.generic = function (parameters) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = parameters.url, methodType = parameters.methodType, headers = parameters.headers, query = parameters.query, payload = parameters.payload;
            if (query) {
                url = encodeURI(url) + _this.appendQuery(query);
            }
            else {
                url = encodeURI(url);
            }
            var method = (methodType ? methodType : 'POST');
            var options = {
                headers: headers,
                url: url,
                data: payload,
                method: method,
            };
            axios_1.default(options)
                .then(function (response) {
                resolve(response.data);
            })
                .catch(function (response) {
                reject(response);
            });
        });
    };
    AxiosClient.prototype.get = function (parameters) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = parameters.url, methodType = parameters.methodType, headers = parameters.headers, query = parameters.query;
            if (query) {
                url = encodeURI(url) + _this.appendQuery(query);
            }
            else {
                url = encodeURI(url);
            }
            var options = {
                headers: headers,
            };
            axios_1.default
                .get(url, options)
                .then(function (response) {
                resolve(response.data);
            })
                .catch(function (response) {
                reject(response);
            });
        });
    };
    AxiosClient.prototype.post = function (parameters) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = parameters.url, methodType = parameters.methodType, headers = parameters.headers, query = parameters.query, payload = parameters.payload;
            if (query) {
                url = encodeURI(url) + _this.appendQuery(query);
            }
            else {
                url = encodeURI(url);
            }
            var options = {
                headers: headers,
            };
            axios_1.default
                .post(url, payload, options)
                .then(function (response) {
                resolve(response.data);
            })
                .catch(function (response) {
                reject(response);
            });
        });
    };
    return AxiosClient;
}(ClientProvider_1.ClientProvider));
exports.AxiosClient = AxiosClient;
//# sourceMappingURL=AxiosClient.js.map